import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import type { GroupSpec, OperationNodeSpec } from '@/graph/domain/types';
import { sectionHeaderSx, sectionBoxSx, labelValueRowSx, labelSx, valueSx } from './info.styles';

interface GroupInfoProps {
  data: GroupSpec & { id: string };
  subSteps: (OperationNodeSpec & { id: string })[];
}

export const GroupInfo: React.FC<GroupInfoProps> = ({ data, subSteps }) => {
  return (
    <Box>
      <Box sx={sectionBoxSx}>
        <Box sx={labelValueRowSx}>
          <Typography sx={labelSx}>Type</Typography>
          <Typography sx={valueSx}>Compound Operation</Typography>
        </Box>
      </Box>

      <Divider />

      {/* Sub-steps */}
      <Typography sx={sectionHeaderSx}>Sub-steps ({subSteps.length})</Typography>
      <Box sx={sectionBoxSx}>
        {subSteps.map((step, i) => (
          <Typography key={step.id} variant="body2" sx={{ py: 0.25 }}>
            {i + 1}. {step.displayName}
          </Typography>
        ))}
        {subSteps.length === 0 && (
          <Typography variant="body2" color="text.secondary">
            No sub-steps.
          </Typography>
        )}
      </Box>

      {/* Cycle Configuration */}
      {data.cycleRanges && data.cycleRanges.length > 0 && (
        <>
          <Divider />
          <Typography sx={sectionHeaderSx}>Cycle Configuration</Typography>
          <Box sx={sectionBoxSx}>
            {data.cycleRanges.map((cycle) => (
              <Box key={cycle.id}>
                <Box sx={labelValueRowSx}>
                  <Typography sx={labelSx}>Cycled steps</Typography>
                  <Typography sx={valueSx}>
                    {cycle.startIndex + 1} → {cycle.endIndex + 1}
                  </Typography>
                </Box>
                <Box sx={labelValueRowSx}>
                  <Typography sx={labelSx}>Count</Typography>
                  <Typography sx={valueSx}>{cycle.iterationCount} cycles</Typography>
                </Box>
              </Box>
            ))}
          </Box>
        </>
      )}

      {/* Notes */}
      {data.notes && (
        <>
          <Divider />
          <Typography sx={sectionHeaderSx}>Notes</Typography>
          <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
            {data.notes}
          </Typography>
        </>
      )}
    </Box>
  );
};
